import React, { useEffect, useState } from "react";
import "./style.scss";
import "../../../style/feature.scss";
import "../../../style/typography.scss";
import "../../../style/block.scss";
import "../../../style/buttons.scss";
import "../../../style/forms.scss";
import { useDispatch, useSelector } from "react-redux";
import { LoginData } from "../../models/LoginData";
import { logInWithPassword } from "../../store/auth/authActions";
import { useNavigate } from "react-router";
import { REGISTRATION_PAGE, REMIND_PASS_PAGE } from "../../routes";
import useFacility from "../../../utils/hooks/useFacility";
import { State } from "../../store";
import { USER_TOKEN } from "../../store/auth/authMiddleware";
import { clearErrors } from "../../store/alerts/alertsActions";

const initialFormLogin: LoginData = {
  login: "",
  password: "",
  objectIds: "",
  old_token: "",
  rememberMe: false,
};

const Login: React.FC = () => {
  const userToken = sessionStorage.getItem(USER_TOKEN);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const facilityIds = useFacility();
  const parsedUserToken = userToken ? JSON.parse(userToken).sessionToken : "";

  const alertLogin = useSelector((state: State) => state.alerts.errors);
  const loading = useSelector((state: State) => state.auth.loading);

  const [form, setForm] = useState<LoginData>({
    ...initialFormLogin,
    objectIds: facilityIds,
    old_token: parsedUserToken,
  });
  useEffect(() => {
    if (Boolean(facilityIds)) {
      setForm({ ...form, objectIds: facilityIds });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [facilityIds]);

  useEffect(() => {
    dispatch(clearErrors());
    //eslint-disable-next-line
  }, []);

  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    dispatch(logInWithPassword(form));
  };

  return (
    <div className="wrap">
      <div className="blob b1"></div>
      <div className="blob b2"></div>
      <div className="wave"></div>

      <section className="card">
        <div className="header">
          <div className="badge" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none">
              <path
                d="M12 2C12 2 5 10 5 14.5C5 18.09 8.134 21 12 21C15.866 21 19 18.09 19 14.5C19 10 12 2 12 2Z"
                stroke="#3aa5f8"
                strokeWidth="1.6"
              />
              <path
                d="M9 14.8c0 1.77 1.79 3.2 3 3.2 1.21 0 3-1.43 3-3.2"
                stroke="#3aa5f8"
                strokeWidth="1.6"
                strokeLinecap="round"
              />
            </svg>
          </div>
          <div className="title">
            <h1>Klub Przyjaciół Term Uniejów — Logowanie</h1>
            <p>Wprowadź dane, aby uzyskać dostęp do konta.</p>
          </div>
        </div>

        <form id="login" onSubmit={handleLogin} noValidate>
          <div className="grid">
            <div>
              <label htmlFor="email">Adres e-mail</label>
              <div className="field">
                <svg className="icon" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M3 7l9 6 9-6M5 6h14a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2Z"
                    stroke="#6aaee6"
                    strokeWidth="1.6"
                  />
                </svg>
                <input
                  id="email"
                  name="email"
                  className="input"
                  type="email"
                  autoComplete="email"
                  value={form.login}
                  onChange={(e) => setForm({ ...form, login: e.target.value })}
                  required
                />
              </div>
            </div>

            <div>
              <label htmlFor="password">Hasło</label>
              <div className="field">
                <svg className="icon" viewBox="0 0 24 24" fill="none">
                  <rect x="3" y="10" width="18" height="10" rx="2" stroke="#6aaee6" strokeWidth="1.6" />
                  <path d="M8 10V7a4 4 0 0 1 8 0v3" stroke="#6aaee6" strokeWidth="1.6" />
                </svg>
                <input
                  id="password"
                  name="password"
                  className="input"
                  type="password"
                  value={form.password}
                  onChange={(e) => setForm({ ...form, password: e.target.value })}
                  required
                />
              </div>
            </div>
          </div>

          {alertLogin && alertLogin.length > 0 && (
            <div className="error" style={{ display: "block", marginTop: "12px" }}>
              {alertLogin}
            </div>
          )}

          <div className="actions">
            <button className="btn" type="submit" disabled={loading}>
              {loading ? "LOGOWANIE..." : "ZALOGUJ"}
            </button>
            <button
              type="button"
              className="alt"
              style={{ background: "none", border: "none", cursor: "pointer", padding: 0 }}
              onClick={() => navigate(REGISTRATION_PAGE)}
            >
              Nie masz konta? Zarejestruj się
            </button>

              <button
              type="button"
              className="alt"
              style={{ background: "none", border: "none", cursor: "pointer", padding: 0 }}
              onClick={() => navigate(REMIND_PASS_PAGE)}
            >
            Nie pamiętam hasła</button>
          </div>
        </form>
      </section>
    </div>
  );
};

export default Login;
